import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import Box from 'components/Box';

const Flex = React.forwardRef(({ display = 'flex', ...props }, ref) => {
    return (
        <Box
            ref={ref}
            display={display}
            {...props}
        />
    );
});

export default wrapFunctionalComponent(Flex, 'Flex');
